import React from 'react';

import loadingSpinnerSVG from '../../assets/img/svg/spinner.svg';

export default class Loader extends React.PureComponent {
  render() {
    return (
      <img src={loadingSpinnerSVG} width="70"/>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js